import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'beautiful-react-hooks';

import logo from '../../../assets/wilson-logo.png';
import { openMenu, closeMenu } from '../../../app/slices/menu/menuSlice';
import { IconButton } from '../../IconButton';
import * as S from './Topbar.styles';
import { AccountSwitcher } from './AccountSwitcher';
import { ProfileOptions } from '../ProfileOptions';

export const Topbar = () => {
	const dispatch = useDispatch();
	const opened = useSelector((state) => state.menu.opened);
	const isHigherThan768 = useMediaQuery('(min-width: 768px)');

	return (
		<S.Topbar>
			<S.NavigationWrapper>
				<S.Wrapper>
					{!isHigherThan768 && <IconButton size={1.25} icon={['fal', 'bars']} onClick={() => (opened ? dispatch(closeMenu()) : dispatch(openMenu()))} />}
					{isHigherThan768 && <AccountSwitcher />}
				</S.Wrapper>
				<S.Picture>
					<img src={logo} alt="" />
				</S.Picture>
				<S.Wrapper alignEnd>
					<ProfileOptions />
				</S.Wrapper>
			</S.NavigationWrapper>
			{!isHigherThan768 && (
				<S.AccountBar>
					<AccountSwitcher />
				</S.AccountBar>
			)}
		</S.Topbar>
	);
};
